import { ServiceGroupDto } from "@apiModels/ServiceGroupDto.csharp";

export const serviceGroupInitialState: ServiceGroupDto = {
  id: "",
  name: "",
  description: "",
  stepHeading: "",
  specializationId: "",
  availableForOnlineBooking: true,
  bookingName: "",
  forcedOffline: false,
  serviceGroupUrl: "",
  services: [],
  isGroup: true,
  sortIndex: 0
};
